import { FC, useEffect, useState } from "react";
import Logo from "./Logo";
import Dropdown from "react-bootstrap/Dropdown";
import { Col, Container, Image, Row, Stack } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import HowToUseModal from "./modals/HowToUseModal";
import Heading from "./Heading";
import AdminModal from "./admin/AdminModal";
import { googleLogout } from "@react-oauth/google";
import { cleanSessionHistory, logOut } from "../api/request";
import { authURL } from "../api/baseUrl";

declare global {
  interface Window {
    gapi: any;
  }
}

const Header: FC = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [chatMode, setChatMode] = useState<string | null>(null);
  const location = useLocation();

  const [howUse, setHowSet] = useState(false);

  const [profilePic, setProfilePic] = useState(
    localStorage.getItem("picture") || ""
  );
  useEffect(() => {
    const storedImage = localStorage.getItem("picture");
    if (storedImage) {
      setProfilePic(storedImage);
    }
  }, []);

  useEffect(() => {
    if (location.pathname === "/chat-mode") {
      setHowSet(true);
    } else {
      setHowSet(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname !== "/chat-screen") {
      document.body?.classList.remove("hide-title");
    } else {
      document.body?.classList.add("hide-title");
    }
  }, [location.pathname]);

  useEffect(() => {
    const chatModeType = localStorage.getItem("chat-mode");
    setChatMode(chatModeType);
  }, [location]);

  const selectedPersona = localStorage.getItem("Persona");

  const handleClick = async () => {
    if (location.pathname === "/chat-screen") {
      const isConfirmed = window.confirm(
        "The chat history will be lost. Are you sure you want to continue?"
      );
      if (isConfirmed) {
        const response = await cleanSessionHistory(selectedPersona);
        if (response?.flag) {
          navigate("/chat-mode");
        }
      } else {
        // console.log('User canceled the action');
      }
    } else {
      navigate("/chat-mode");
    }
  };

  const googleLogOutFn = async () => {
    try {
      const result = await logOut();
      if (result?.flag) {
        googleLogout();

        //      // Save uni info before clearing
        //   const uniId = localStorage.getItem("universityId");
        //   const uniContainer = localStorage.getItem("uniStorageContainer");

        //   localStorage.clear();
        //   sessionStorage.clear();

        //   if (uniId) localStorage.setItem("universityId", uniId);
        //   if (uniContainer) localStorage.setItem("uniStorageContainer", uniContainer);

        localStorage.clear();
        sessionStorage.clear();
        // window.location.href = authURL;
        window.location.href = "/";
      }
    } catch (error) {
      console.error("Error during Google logout:", error);
    }
  };

  return (
    <>
      {howUse && (
        <HowToUseModal
          setShow={show}
          onClose={() => setShow(false)}
          setHowSets={setHowSet}
        />
      )}
      <AdminModal show={admin} onClose={() => setAdmin(false)} />
      <header>
        <Container>
          <Row className="justify-content-between">
            <Col
              id="no-print"
              md={{ order: 1, span: 2 }}
              xs={{ order: 1, span: 6 }}
            >
              <div onClick={handleClick}>
                <Logo />
              </div>
            </Col>
            {location.pathname !== "/chat-screen" ? (
              ""
            ) : (
              <Col md={{ order: 2, span: 8 }} xs={{ order: 3, span: 12 }}>
                <Heading />
              </Col>
            )}
            <Col
              id="no-print"
              md={{ order: 3, span: 2 }}
              xs={{ order: 2, span: 6 }}
              className="text-end"
            >
              <Stack
                direction="horizontal"
                gap={3}
                className="justify-content-end"
              >
                <Dropdown align="end">
                  <Dropdown.Toggle
                    variant=""
                    className="p-0"
                    id="dropdown-basic"
                  >
                    <div className="hamburger" id="hamburger-1">
                      <span className="line"></span>
                      <span className="line"></span>
                      <span className="line"></span>
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item href="#" onClick={handleClick}>
                      Home
                    </Dropdown.Item>
                    {location.pathname === "/chat-mode" && (
                      <Dropdown.Item
                        href="#"
                        onClick={() => {
                          setAdmin(true);
                        }}
                      >
                        Admin
                      </Dropdown.Item>
                    )}

                    <Dropdown.Item
                      href="#"
                      onClick={() => {
                        setHowSet(true);
                        setShow(true);
                      }}
                    >
                      Instructions
                    </Dropdown.Item>
                    <Dropdown.Item href="/feedback" target="_blank">
                      Feedback
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <Dropdown align="end">
                  <Dropdown.Toggle
                    variant=""
                    className="p-0"
                    id="dropdown-basic"
                  >
                    <div className="profile-icon">
                      <Image src={profilePic && profilePic} />
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      href="#"
                      onClick={() => {
                        if (location?.pathname === "/chat-screen") {
                          const confirmLogout = window.confirm(
                            "The chat history will be lost. Are you sure you want to logout?"
                          );
                          if (confirmLogout) {
                            googleLogOutFn();
                          }
                        } else {
                          const confirmLogout = window.confirm(
                            "Are you sure you want to logout?"
                          );
                          if (confirmLogout) {
                            googleLogOutFn();
                          }
                        }
                      }}
                    >
                      Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Stack>
            </Col>
            {location.pathname === "/chat-screen" ? (
              ""
            ) : (
              <Col className="mt-4 mb-3" xs={{ order: 3, span: 12 }}>
                <Heading />
              </Col>
            )}
          </Row>
        </Container>
      </header>
    </>
  );
};
export default Header;
